import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
function LegalModal({
  type,
  onClose
}: {
  type: 'privacy' | 'terms';
  onClose: () => void;
}) {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.2
  }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-charcoal/60 backdrop-blur-sm" onClick={onClose} data-id="element-50">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95,
      y: 20
    }} animate={{
      opacity: 1,
      scale: 1,
      y: 0
    }} exit={{
      opacity: 0,
      scale: 0.95,
      y: 20
    }} transition={{
      duration: 0.25
    }} className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[80vh] overflow-hidden flex flex-col" onClick={e => e.stopPropagation()} data-id="element-51">
        <div className="flex items-center justify-between px-6 py-4 border-b border-cream-dark bg-cream" data-id="element-52">
          <h2 className="text-xl font-bold text-charcoal font-serif" data-id="element-53">
            {type === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
          </h2>
          <button onClick={onClose} className="p-1.5 rounded-full hover:bg-charcoal/10 transition-colors" aria-label="Cerrar" data-id="element-54">
            <X className="w-5 h-5 text-charcoal" data-id="element-55" />
          </button>
        </div>

        <div className="overflow-y-auto p-6 text-sm text-charcoal-light leading-relaxed space-y-4" data-id="element-56">
          {type === 'privacy' ? <PrivacyContent data-id="element-57" /> : <TermsContent data-id="element-58" />}
        </div>
      </motion.div>
    </motion.div>;
}
function PrivacyContent() {
  return <>
      <p className="text-xs text-charcoal-light/70" data-id="element-59">
        Última actualización: Abril 2026
      </p>

      <h3 className="font-bold text-charcoal text-base" data-id="element-60">
        1. Información que Recopilamos
      </h3>
      <p data-id="element-61">
        Recopilamos únicamente la información necesaria para procesar tu compra
        y entregarte el producto digital: nombre, dirección de correo
        electrónico y datos de pago. No almacenamos datos de tarjetas de crédito
        directamente; estos son procesados de forma segura por nuestro proveedor
        de pagos.
      </p>

      <h3 className="font-bold text-charcoal text-base" data-id="element-62">
        2. Uso de la Información
      </h3>
      <p data-id="element-63">
        Tu información personal se utiliza exclusivamente para: procesar y
        entregar tu pedido, enviarte actualizaciones relacionadas con tu compra,
        y mejorar nuestros productos y servicios. No vendemos, alquilamos ni
        compartimos tu información personal con terceros con fines de marketing.
      </p>

      <h3 className="font-bold text-charcoal text-base" data-id="element-64">
        3. Protección de Datos
      </h3>
      <p data-id="element-65">
        Implementamos medidas de seguridad técnicas y organizativas para
        proteger tu información personal contra acceso no autorizado,
        alteración, divulgación o destrucción. Toda la comunicación se realiza
        mediante conexiones cifradas (SSL/TLS).
      </p>

      <h3 className="font-bold text-charcoal text-base" data-id="element-66">4. Cookies</h3>
      <p data-id="element-67">
        Utilizamos cookies esenciales para el funcionamiento del sitio y cookies
        analíticas para entender cómo los visitantes interactúan con nuestra
        página. Puedes desactivar las cookies en la configuración de tu
        navegador.
      </p>

      <h3 className="font-bold text-charcoal text-base" data-id="element-68">5. Tus Derechos</h3>
      <p data-id="element-69">
        Tienes derecho a acceder, rectificar, eliminar o limitar el tratamiento
        de tus datos personales. Para ejercer estos derechos, puedes
        contactarnos a través de los canales indicados en nuestra página.
      </p>

      <h3 className="font-bold text-charcoal text-base" data-id="element-70">
        6. Cambios en esta Política
      </h3>
      <p data-id="element-71">
        Nos reservamos el derecho de actualizar esta política de privacidad en
        cualquier momento. Los cambios serán publicados en esta página con la
        fecha de última actualización.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-xs text-charcoal-light/70" data-id="element-72">
        Última actualización: Abril 2026
      </p>

      <h3 className="font-bold text-charcoal text-base" data-id="element-73">
        1. Aceptación de los Términos
      </h3>
      <p data-id="element-74">
        Al acceder y realizar una compra en este sitio web, aceptas estar sujeto
        a estos Términos y Condiciones. Si no estás de acuerdo con alguna parte
        de estos términos, no debes utilizar nuestro sitio ni adquirir nuestros
        productos.
      </p>

      <h3 className="font-bold text-charcoal text-base" data-id="element-75">2. Producto Digital</h3>
      <p data-id="element-76">
        El "Reinicio Hormonal 40+" es un producto digital (ebook en formato PDF)
        que se entrega de forma inmediata tras la confirmación del pago. El
        contenido es informativo y educativo, y no constituye consejo médico
        profesional.
      </p>

      <h3 className="font-bold text-charcoal text-base" data-id="element-77">
        3. Descargo de Responsabilidad Médica
      </h3>
      <p data-id="element-78">
        Este producto no sustituye el consejo, diagnóstico o tratamiento médico
        profesional. Siempre consulta a tu médico u otro profesional de la salud
        cualificado antes de realizar cambios en tu dieta o estilo de vida. Los
        resultados pueden variar de persona a persona.
      </p>

      <h3 className="font-bold text-charcoal text-base" data-id="element-79">
        4. Política de Reembolso
      </h3>
      <p data-id="element-80">
        Ofrecemos una garantía de devolución de dinero de 30 días. Si no estás
        satisfecha con el producto por cualquier motivo, puedes solicitar un
        reembolso completo dentro de los 30 días posteriores a la compra
        enviándonos un correo electrónico.
      </p>

      <h3 className="font-bold text-charcoal text-base" data-id="element-81">
        5. Propiedad Intelectual
      </h3>
      <p data-id="element-82">
        Todo el contenido del ebook, incluyendo textos, gráficos, imágenes y
        diseño, está protegido por derechos de autor. La compra otorga una
        licencia personal e intransferible. Queda prohibida la reproducción,
        distribución o reventa del contenido sin autorización expresa.
      </p>

      <h3 className="font-bold text-charcoal text-base" data-id="element-83">
        6. Limitación de Responsabilidad
      </h3>
      <p data-id="element-84">
        En ningún caso seremos responsables por daños directos, indirectos,
        incidentales o consecuentes derivados del uso o la imposibilidad de uso
        de nuestros productos o servicios.
      </p>
    </>;
}
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-charcoal text-white/50 py-6 sm:py-8 text-center text-sm" data-id="element-85">
        <div className="max-w-4xl mx-auto px-4 space-y-3" data-id="element-86">
          <div className="flex items-center justify-center gap-4" data-id="element-87">
            <button onClick={() => setActiveModal('privacy')} className="text-white/60 hover:text-white transition-colors underline underline-offset-2 text-xs sm:text-sm" data-id="element-88">
              Política de Privacidad
            </button>
            <span className="text-white/30" data-id="element-89">|</span>
            <button onClick={() => setActiveModal('terms')} className="text-white/60 hover:text-white transition-colors underline underline-offset-2 text-xs sm:text-sm" data-id="element-90">
              Términos y Condiciones
            </button>
          </div>
          <p className="text-xs sm:text-sm" data-id="element-91">
            © {new Date().getFullYear()} Reinicio Hormonal 40+. Todos los
            derechos reservados.
          </p>
          <p className="text-xs text-white/40" data-id="element-92">
            Este producto no sustituye el consejo médico profesional.
          </p>
        </div>
      </footer>

      <AnimatePresence data-id="element-93">
        {activeModal && <LegalModal type={activeModal} onClose={() => setActiveModal(null)} data-id="element-94" />}
      </AnimatePresence>
    </>;
}